<div class="table-container">
  <table [formGroup]="formGroup">
    <thead>
      <tr class="mat-header-row caption-row" *ngIf="showCaptionRow">
        <th class="mat-header-cell">
          <mat-checkbox
            class="easy-checkbox"
            [checked]="(isAllMerchantsSelected$ | async) !== 'NOT_CHECKED'"
            [indeterminate]="
              (isAllMerchantsSelected$ | async) === 'INDETERMINATE'
            "
            #groupOfGroupsCheckbox
            (change)="
              toggleAllMerchants(
                groupOfGroupsCheckbox.indeterminate
                  ? true
                  : groupOfGroupsCheckbox.checked
              )
            "
          >
          </mat-checkbox>
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.PRODUCT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DISCOUNT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_FROM" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_TO" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
        </th>
        <th class="mat-header-cell"></th>
      </tr>
      <tr class="mat-header-row sub-header">
        <th class="mat-header-cell checkboxes-header">
          <mat-checkbox
            class="easy-checkbox"
            #groupCheckbox
            [checked]="
              (isMerchantAllProductsSelected$ | async) !== 'NOT_CHECKED'
            "
            [indeterminate]="
              (isMerchantAllProductsSelected$ | async) === 'INDETERMINATE'
            "
            (change)="
              toggleAll(
                groupCheckbox.indeterminate ? true : groupCheckbox.checked
              )
            "
          >
          </mat-checkbox>
        </th>
        <th class="mat-header-cell" colspan="5">
          {{ discountToMerchant.merchant.companyName }}
        </th>
        <th class="mat-header-cell"></th>
      </tr>
    </thead>

    <tbody formArrayName="vipDiscountList" *ngIf="formArray">
      <tr
        *ngFor="let group of formArray.controls; let index = index"
        [formGroupName]="index"
        class="mat-row"
      >
        <td class="mat-cell checkboxes-column">
          <mat-checkbox
            #cbx
            class="me-2 easy-checkbox"
            (change)="
              toggle(
                discountToMerchant.vipDiscountList[index].packagingUnitId ?? ''
              )
            "
            [checked]="
              isProductChecked(
                discountToMerchant.vipDiscountList[index].packagingUnitId ?? ''
              )
            "
          >
          </mat-checkbox>
        </td>
        <td class="mat-cell">
          {{ discountToMerchant.vipDiscountList[index].label }}
        </td>
        <td class="mat-cell">
          <div class="discount-cell easy-form">
            <mat-form-field class="value-field">
              <app-easy-input
                formControlName="discountValue"
                type="number"
                [min]="0"
                [max]="
                  formArray.at(index).get('discountMode')?.value === 'PERCENT'
                    ? 100
                    : undefined
                "
                [maxDecimals]="2"
              ></app-easy-input>
            </mat-form-field>
            <mat-form-field>
              <app-easy-select
                formControlName="discountMode"
                [options]="discountModeOptions"
                [labelAttribute]="'label'"
                [valueAttribute]="'value'"
                [hasEmptyOption]="false"
                (ngModelChange)="discountModeChanged(index)"
              ></app-easy-select>
            </mat-form-field>
          </div>
        </td>
        <td class="mat-cell">
          <div class="easy-form">
            <mat-form-field>
              <div class="form-field-container">
                <input
                  formControlName="startDate"
                  [matDatepicker]="pickerFrom"
                  class="suffix"
                  matInput
                  (focus)="pickerFrom.open()"
                />
                <span matSuffix (click)="pickerFrom.open()">
                  <mat-icon>today</mat-icon>
                </span>
                <mat-datepicker #pickerFrom></mat-datepicker>
              </div>
            </mat-form-field>
          </div>
        </td>
        <td class="mat-cell">
          <div class="easy-form">
            <mat-form-field>
              <div class="form-field-container">
                <input
                  formControlName="endDate"
                  [matDatepicker]="pickerTo"
                  class="suffix"
                  matInput
                  [min]="
                    formArray.at(index).get('startDate')?.value
                      ? formArray.at(index).get('startDate')?.value
                      : today
                  "
                  (focus)="pickerTo.open()"
                />
                <span matSuffix (click)="pickerTo.open()">
                  <mat-icon>today</mat-icon>
                </span>
                <mat-datepicker #pickerTo></mat-datepicker>
              </div>
            </mat-form-field>
          </div>
        </td>
        <td class="mat-cell">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="showOriginalPrice(index)"
          >
            {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
          </button>
        </td>
        <td class="mat-cell">
          <button
            type="button"
            mat-icon-button
            class="ms-2"
            (click)="
              deleteDiscount(
                discountToMerchant.vipDiscountList[index].packagingUnitId ?? ''
              )
            "
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
